var _defs, _line, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fc7cc657-ca91-49ac-bf0a-413106bffe0a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.05 10.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e2fb1746-0973-4394-a9b7-983f4cd4ae2e{fill:none;stroke:#fff;stroke-miterlimit:10;}.ba1d9e9a-6a38-4d20-ba42-d98a680a8b3a{fill:#fff;fill-rule:evenodd;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "e2fb1746-0973-4394-a9b7-983f4cd4ae2e",
    x1: 9.05,
    y1: 5.11,
    x2: 24.05,
    y2: 5.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "ba1d9e9a-6a38-4d20-ba42-d98a680a8b3a",
    points: "0 5.31 9.19 0 9.19 10.61 0 5.31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.7d605f8b514a034387a3b003f3ccc8f9.svg";
export { ForwardRef as ReactComponent };